import React from 'react';

function SortItems({ fill = '#1D1C1D', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 15V13.75H7.5V15H2.5ZM2.5 10.625V9.375H12.5V10.625H2.5ZM2.5 6.25V5H17.5V6.25H2.5Z" fill={fill} />
    </svg>

  );
}

export default SortItems;
